<template>
	<div class="fullBoxs" v-loading.fullscreen.lock="fullscreenLoading">
		<div class="fullBox">
			<crumbs type="2" height="53px" />
			<div class="bodyWrapper">
				<div class="gudBtns" style="top: 0px;">
					<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
						<img src="@/assets/img/back.svg" alt="" />
						<span>返回</span>
					</div>
				</div>
				<div class="exam-switch-box">
					<span :class="{ active: examType == 'A' }" @click="switchExam('A')">A卷</span>
					<span :class="{ active: examType == 'B' }" @click="switchExam('B')">B卷</span>
				</div>
				<div class="kaoshiBox">
					<div class="kaoshiFs">
						<p>分数</p>
						<span>{{ decData.score }}</span>
					</div>
					<div class="kaoshiCont">
						<h1>{{ decData.name }}</h1>
						<h2 style="font-weight: bold;">（选择题{{ tmTnum.num }}小题，每题{{ configData.configValue || '' }}分，共{{ tmTnum.num *
							configData.configValue || '' }}分）</h2>
						<div class="kaoshiTm">
							<h3>第一节</h3>
							<p>听下面5段录音。每段录音后有一个小题，从题中所给的A、B、C三个选项中选出最佳选项。听完每段录音后，你都有10秒钟的时间来回答有关小题和阅读下一小题。每段录音播放两遍。</p>
							<div class="kaoshiXtim" v-for="(item, index) in tmDec.yydTextbookQuestions?.slice(0, 5)"
								:key="index">
								<h4 v-if="item.tmName">{{ item.tmName }}</h4>
								<div class="kaoshiT" :class="{ cwActive: a.yydAnswerQuestion.correctFlag == 0 }"
									v-for="(a, b) in item.yydSmallQuestionList" :key="b">
									<div class="kaoshiWt">
										<div class="kaoshiDa">
											<i>(</i>
											<span>{{ a.yydAnswerQuestion.userAnswer }}</span>
											<i>)</i>
										</div>
										<div class="tips">{{ a.num }}、{{ a.title }}</div>
										<jting-button @btns="jtBtns(item)" @qkFn="qkFn" :ref="'jting'" />
									</div>
									<div class="kaoshiXx">
										<p :class="{ active: a.yydAnswerQuestion.userAnswer == i.number }"
											v-for="(i, s) in a.yydSmallQuestionOptionList" :key="s">
											{{ i.number }}、{{ i.content }}
										</p>
									</div>
									<div class="lookJx" @click="toggleJx(a)">
										查看解析
										<i class="el-icon-caret-bottom" v-if="!a.jxFlag"></i>
										<i class="el-icon-caret-top" v-if="a.jxFlag"></i>
									</div>
									<div class="lookDaBox" v-show="a.jxFlag">
										<div class="lookDaTit">正确答案：{{ a.yydAnswerQuestion.answer }}</div>
										<div class="lookDaCont">
											<p v-html="item.originalContent"></p>
										</div>
										<div class="lookDaBtn supHove3" @click="tltBtn(a, item)">同类题</div>
									</div>
								</div>
							</div>
						</div>
						<div class="kaoshiTm">
							<h3>第二节</h3>
							<p>听下面5段录音。每段录音后有几个小题，从题中所给的A、B、C三个选项中选出最佳选项。听每段录音前，你将有时间阅读各个小题，每小题5秒钟;听完后，每小题都有5秒钟的作答时间。每段录音播放两遍。
							</p>
							<div class="kaoshiXtim" v-for="(item, index) in tmDec.yydTextbookQuestions?.slice(5)"
								:key="index">
								<h4>
									听第{{ 6 + index }}段录音，回答第{{ getQuestionRangeText(item) }}题。
									<jting-button @btns="jtBtns(item)" @qkFn="qkFn" :ref="'jting'" />
								</h4>
								<h4 v-if="item.tmName">{{ item.tmName }}</h4>
								<div class="kaoshiT" :class="{ cwActive: a.yydAnswerQuestion.correctFlag == 0 }"
									v-for="(a, b) in item.yydSmallQuestionList" :key="b">
									<div class="kaoshiWt">
										<div class="kaoshiDa">
											<i>(</i>
											<span>{{ a.yydAnswerQuestion.userAnswer }}</span>
											<i>)</i>
										</div>
										<div class="tips">{{ a.num }}、{{ a.title }}</div>
									</div>
									<div class="kaoshiXx">
										<p :class="{ active: a.yydAnswerQuestion.userAnswer == i.number }"
											v-for="(i, s) in a.yydSmallQuestionOptionList" :key="s">
											{{ i.number }}、{{ i.content }}
										</p>
									</div>
								</div>
								<div
									:class="{ cwActive: item.yydSmallQuestionList.filter((item) => item.yydAnswerQuestion.correctFlag == 0).length ? true : false }">
									<div class="lookJx" @click="toggleJx(item)">
										查看解析
										<i class="el-icon-caret-bottom" v-if="!item.jxFlag"></i>
										<i class="el-icon-caret-top" v-if="item.jxFlag"></i>
									</div>
									<div class="lookDaBox" v-show="item.jxFlag">
										<div class="lookDaTit">正确答案：{{item.yydSmallQuestionList.map((item) =>
											item.answer).join(' ')}}</div>
										<div class="lookDaCont">
											<p v-html="item.originalContent"></p>
										</div>
										<div class="lookDaBtn supHove3"
											@click="tltBtn(item.yydSmallQuestionList[0], item)">同类题</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import crumbs from '@/components/hearder/crumbs';
import axios from 'axios';

export default {
	name: 'kaoshiZj',
	data() {
		return {
			a: ['个人中心'],
			txt: '',
			setFn: '',
			fullscreenLoading: false,
			decData: {},
			tmDec: {},
			configData: {},
			tmTnum: {
				num: 0
			},
			examType: 'A',
			paperId: '',
			recordId: ''
		};
	},
	components: {
		crumbs,
	},
	beforeDestroy() {
		if (this.setFn) {
			clearInterval(this.setFn);
		}
	},
	methods: {
		switchExam(type) {
			this.examType = type;
			this.handleViewAnswer();
		},
		handleViewAnswer() {
			const payload = {
				paperId: this.paperId,
				type: this.examType,
				recordId: this.recordId
			};
			this.fullscreenLoading = true
			this.$http
				.post('api/app/yydComputerizedExamPaper/examResultDetail', payload)
				.then((res) => {
					this.fullscreenLoading = false
					this.decData = res.data;

					const obj = {
						yydTextbookQuestions: this.decData.yydGroupExamQuestionBodyDtoList || this.decData.questionList || []
					};

					if (obj.yydTextbookQuestions.length) {
						let datas = obj;
						let num = 1;
						datas.yydTextbookQuestions.forEach((item) => {
							this.$set(item, 'jxFlag', false);
							item.yydSmallQuestionList.forEach((i) => {
								this.$set(i, 'jxFlag', false);
								i.num = num;
								num++;
							});
						});
						this.tmTnum.num = num - 1;
						this.tmDec = datas;
						console.log(this.tmDec, 222);
					}

				})
				.catch(() => null);
		},
		getQuestionRangeText(item) {
			const list = this.getSmallQuestions(item);
			if (list.length <= 0) return '';
			if (list.length > 2) return `${list[0].num}至${list[list.length - 1].num}`;
			return list.map((i) => i && i.num).filter(Boolean).join('、');
		},
		getSmallQuestions(item) {
			const list = item && (item.smallQuestions || item.yydSmallQuestionList);
			return Array.isArray(list) ? list : [];
		},
		qkFn() {
			console.log(this.$refs['jting'].length, 9999);
			if (this.$refs['jting'].length) {
				this.$refs['jting'].forEach((item) => {
					item.btnFlag = false;
					item.bfFlag = true;
				});
			} else {
				this.$refs['jting'].btnFlag = false;
				this.$refs['jting'].bfFlag = true;
			}
		},
		toggleJx(target) {
			if (!target) return;
			this.$set(target, 'jxFlag', !target.jxFlag);
		},
		jtBtns(item) {
			console.log(item.recordingFileId, 7777);
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/common/getUrl', {
					params: {
						fileId: item.recordingFileId,
						clientType: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						axios({
							method: 'get',
							url: res.msg,
							// timeout: 600000, // 请求超时时间，数据量多后台响应慢的情况可以调大点，没生效的话可能是vue.config.js里的配置影响了
							responseType: 'blob', // 返回类型为数据流
							headers: {
								clientType: 1,
								token: `${localStorage.getItem('token')}`
							}
						}).then((red) => {
							if (red && red.data) {
								const blob = new Blob([red.data], { type: 'audio/mpeg' });
								this.$audio.init(URL.createObjectURL(blob), (r) => { });
								this.$nextTick((r) => {
									this.$audio.play();
								});
							}
						});
					}
				});
		},
		init() {
			// 得分
			this.$http.get(`api/system/dict/data/config/sys.question.score`).then((res) => {
				if (res.code == 200) {
					this.configData = res.data;
				}
			});
		},
		tltBtn(item, is) {
			console.log(item, is, 8887);
			let str = this.a[2] + '~' + '同类题';
			this.$router.push({
				path: 'jikaoSt',
				query: {
					txt: str,
					tabFtxt: this.a[1],
					testCenterName: is.testCenterName ? is.testCenterName : '',
					smallQuestionId: item.smallQuestionId
				}
			});
		},
	},
	async mounted() {
		const {
			txt,
			tabFtxt,
			paperId,
			recordId,
		} = this.$route.query;

		this.paperId = paperId;
		this.recordId = recordId;

		if (tabFtxt) {
			this.a = typeof tabFtxt == 'string' ? [tabFtxt] : [...tabFtxt];
		}
		this.txt = txt || '';
		if (txt.includes('~')) {
			this.a.push(...txt?.split('~'));
		} else {
			this.a.push(txt);
		}
		this.handleViewAnswer();
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.tcBox {
	margin: 6px 0 40px;
	display: flex;
	justify-content: space-between;

	.tcItem {
		width: 133px;
		height: 93px;
		background: #f8f9fd;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 16px;

		img {
			width: 34px;
			height: 34px;
			margin-bottom: 7px;
		}
	}

	.tcItem1 {
		color: #000000;
	}

	.tcItem2 {
		color: #10c257;
	}

	.tcItem3 {
		color: #ffb126;
	}
}

.footerP {
	text-align: center;
	font-size: 14px;
	color: #82807c;
	margin-top: 12px;

	span {
		color: #1d7b3a;
		margin-right: 4px;
	}
}

.dialog-footer {
	display: flex;
	justify-content: center;
	padding-bottom: 10px;

	.loadBtn {
		width: 88px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		background: #d33931;
		box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
		font-size: 16px;
		color: #ffffff;
		border-radius: 6px;
		cursor: pointer;
	}

	.loadBtnQr {
		background: #1d7b3a;
		color: #ffffff;
		margin-left: 50px;
	}
}

.fullBox1 {
	background: #e8e3d7 !important;



	.kaoshiBox {
		background: #f4f0e7 !important;
	}

	.kaoshiCont {
		color: #484745 !important;

		h2 {
			border-bottom: 1px solid #ddd9d2 !important;
		}
	}
}

.fullBox2 {
	background: #202020 !important;

	.kaoshiBox {
		background: #252525 !important;
	}

	.kaoshiCont {
		color: #b3b3b3 !important;

		h2 {
			border-bottom: 1px solid #979797 !important;
		}
	}

	.kaoshiFixBtn {
		background: #252525 !important;
		color: #82807c !important;
	}
}

.fullBox {
	background: #f3f4f7;
	min-height: calc(100vh - 113px);

	.exam-switch-box {
		width: 1200px;
		margin: 0 auto 10px;
		display: flex;
		justify-content: space-between;
		gap: 20px;
		// padding: 0 20px;
		box-sizing: border-box;

		span {
			flex: 1;
			height: 58px;
			line-height: 58px;
			text-align: center;
			border: 1px solid #e6e6e6;
			cursor: pointer;
			font-size: 26px;
			font-weight: 700;
			color: #0a7aff;
			background-color: #fff;
			border-radius: 8px;

			&.active {
				background: #0a7aff;
				color: #fff;
				border-color: #0a7aff;
			}
		}
	}

	.kaoshiBox {
		width: 1200px;
		margin: 0 auto 0;
		position: relative;
		background: #ffffff;
		border-radius: 4px;
		padding: 0 80px 20px 50px;
		box-sizing: border-box;



		.kaoshiFs {
			position: absolute;
			width: 121px;
			height: 112px;
			top: 23px;
			right: 93px;
			text-align: center;
			background: url('@/assets/img/形状结合.svg');

			p {
				font-size: 14px;
				color: #ee0a24;
				margin-top: 14px;
			}

			span {
				font-size: 52px;
				color: #ee0a24;
				font-family: 'fsFont';
				font-weight: bold;
				font-style: italic;
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				top: 16px;
			}
		}

		.kaoshiCont {
			padding: 0 80px 0 51px;
			color: #000000;

			h1 {
				font-size: 28px;
				padding-top: 38px;
				margin-bottom: 25px;
				font-weight: bold;
				text-align: center;
			}

			h2 {
				font-size: 18px;
				margin-bottom: 27px;
				text-align: center;
				padding-bottom: 34px;
				border-bottom: 1px solid #f8f8f8;
			}

			.kaoshiTm {
				h3 {
					font-size: 18px;
					font-weight: bold;
					margin: 40px 0 13px;
					text-indent: 2em;
				}

				>p {
					font-size: 16px;
					line-height: 2;
					text-indent: 2em;
					margin-bottom: 38px;
				}

				.kaoshiXtim {
					margin-left: 2em;
					margin-bottom: 20px;

					h4 {
						font-weight: bold;
						font-size: 18px;
						margin: 40px 0;
						display: flex;
						align-items: center;
					}

					.kaoshiT {
						margin-bottom: 40px;

						&:last-of-type {
							margin-bottom: 0;
						}

						.kaoshiXx {
							padding-left: 102px;

							p {
								margin-bottom: 36px;
								font-size: 18px;
								cursor: pointer;

								&:last-of-type {
									margin-bottom: 0;
								}
							}

							.active {
								color: #1d7b3a;
							}
						}

						.kaoshiWt {
							display: flex;
							font-weight: bold;
							margin-bottom: 36px;

							.kaoshiDa {
								width: 72px;
								margin-right: 30px;
								position: relative;
								display: flex;
								justify-content: space-between;

								span {
									position: absolute;
									top: 50%;
									left: 50%;
									transform: translate(-50%, -50%);
									line-height: 1;
									margin-top: -1px;
								}
							}
						}
					}
				}
			}
		}

		.kaoshiFixBtns {
			position: absolute;
			right: -82px;
			top: 0;

			.kaoshiFixBtn {
				width: 65px;
				height: 65px;
				background: #ffffff;
				border-radius: 6px;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				font-size: 14px;
				color: #82807c;
				margin-bottom: 15px;
				cursor: pointer;

				img {
					width: 25px;
					height: 25px;
					margin-bottom: 4px;
				}
			}

			.kaoshiFixBtn1 {
				background: #d33931;
				color: #fff;
			}
		}

		.kaoshiFixYs {
			position: absolute;
			top: 22px;
			right: 7px;
			width: 108px;
			height: 98px;
			color: #fff;
			background: url('@/assets/img/ys.svg') 100% no-repeat;

			.kaoshiFixYsCont {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				margin-top: -4px;
			}

			.kaoshiFixP {
				position: absolute;
				bottom: 15px;
				width: 100%;
				display: flex;
				justify-content: center;
				font-size: 12px;
				align-items: center;

				p {
					margin: 0 6px;
				}

				img {
					width: 9px;
					height: 6px;
					cursor: pointer;
					margin-top: 1px;
				}

				.img1 {
					transform: rotate(90deg);
				}

				.img2 {
					transform: rotate(90deg);
				}
			}
		}
	}
}

.tlTabs {
	padding: 4px;
	background: #fff;
	border-radius: 4px;
	display: flex;
	margin: 0 auto 10px;
	width: 1200px;
	box-sizing: border-box;

	.tlTabItem {
		flex: 1;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		color: #6d6e70;
		border-radius: 4px;
		cursor: pointer;

		img {
			width: 26px;
			height: 26px;
			margin-right: 5px;
		}

		:first-of-type {
			margin-right: 4px;
		}
	}

	.active {
		background: linear-gradient(180deg, #1d7b3a 0%, #1d7b3a 100%);
		color: #fff;
	}
}

.ciBox {
	background: #ffffff;
	width: 1200px;
	margin: 0 auto;
	box-sizing: border-box;
}

.cihuiBox {
	.cihuiCont {
		margin-bottom: 18px;
		padding: 0 22px;

		.cihuiItem {
			padding: 18px 0;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #f8f8f8;

			&:last-of-type {
				border-bottom: none;
			}

			.cihuiItemRig {
				.cihuiItemRigT {
					display: flex;
					margin-bottom: 8px;

					.cihuiItemRigTBtn {
						padding: 5px 12px;
						font-size: 12px;
						border-radius: 4px;
						margin-left: 10px;
					}

					.cihuiItemRigTBtn1 {
						background: #ffeef8;
						color: #d7198b;
					}

					.cihuiItemRigTBtn2 {
						background: #eef6ff;
						color: #1f6cf5;
					}

					.cihuiItemRigTBtn3 {
						background: #fff4ee;
						color: #f07c10;
					}
				}

				p {
					color: #878787;
					margin-top: 8px;
					font-size: 12px;
					text-align: right;
				}
			}

			.cihuiItemLef {
				display: flex;
				flex-direction: column;
				justify-content: center;

				.fgP {
					display: flex;
					align-items: center;

					img {
						margin-top: 3px;
					}
				}

				h2 {
					font-size: 24px;
					color: #000000;
					margin: 0 11px 0 0;
					font-weight: bold;
				}

				p {
					font-size: 14px;
					color: #000000;
					margin-right: 10px;
				}

				>p {
					color: #1d7b3a;
					margin-top: 10px;
				}

				img {
					width: 21px;
					height: 21px;
					cursor: pointer;
				}

				.ass {
					color: #000000;
				}
			}
		}
	}

	.cihuiBoxTit {
		height: 67px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #f8f8f8;
		justify-content: space-between;
		padding: 0 26px;

		.cihuiBoxQx {
			font-size: 18px;
			color: #8d8d8d;
			display: flex;
			align-items: center;

			h2 {
				margin-right: 47px;
				cursor: pointer;
			}

			.qxActive {
				color: #000000;
				font-weight: bold;
			}
		}

		.cihuiBoxBtns {
			display: flex;

			.cihuiBoxBtn {
				width: 100px;
				height: 36px;
				background: linear-gradient(180deg, #ffffff 0%, #f1f1f1 100%);
				border-radius: 7px;
				border: 1px solid #e0e0e0;
				margin-left: 16px;
				font-size: 14px;
				color: #000000;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;

				img {
					width: 16px;
					height: 16px;
					margin-right: 5px;
				}
			}

			.cihuiBoxBtn1 {
				background: #1d7b3a;
				border: 1px solid #14652d;
				color: #fff;
			}
		}
	}
}

.kaoshiWtBtn {
	margin-left: 19px;
	width: 63px;
	height: 26px;
	background: #1d7b3a;
	border-radius: 4px;
	color: #fff;
	font-size: 14px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 400;
	cursor: pointer;

	img {
		width: 16px;
		height: 14px;
		margin-right: 6px;
	}
}

.lookJx {
	color: #1d7b3a;
	cursor: pointer;
	margin: 30px 0 20px 0;
}

.lookDaBox {
	margin-left: 0;

	.lookDaTit {
		font-weight: bold;
		font-size: 18px;
		margin-bottom: 16px;
	}

	.lookDaCont {
		margin-bottom: 20px;
		line-height: 2;
		font-size: 16px;
		color: #000000;

		span {
			color: #1d7b3a;
		}
	}

	.lookDaBtn {
		width: 88px;
		height: 40px;
		border: 1px solid #1d7b3a;
		text-align: center;
		line-height: 40px;
		font-size: 16px;
		color: #1d7b3a;
		cursor: pointer;
		border-radius: 6px;
	}
}

.cwActive {
	.kaoshiXx {
		p {
			color: #d33931 !important;
		}
	}

	.tips,
	.lookJx,
	.lookDaTit {
		color: #d33931 !important;
	}

	.lookDaCont {
		span {
			color: #d33931 !important;
		}
	}
}
</style>
